<template>
    <div class="row">
        <div class="col-lg-4 col-md-5">
            <b-card class="sticky" body-class="p-1">
                <advance-payment-assign v-model="assignData" :errors="errors"></advance-payment-assign>
                <div class="d-flex align-items-center justify-content-end">
                    <b-form-checkbox class="mr-2" v-model="assignData.ExitedEmployees">Çıkan personeller dahil</b-form-checkbox>
                    <v-executer :loading="calculating" text="Hesapla" :action="calculate"></v-executer>
                </div>
            </b-card>
        </div>
        <div class="col-lg-8 col-md-7">
            
            <b-modal id="create-group-key" title="Banka Dosyası Kimliği Oluştur" no-close-on-esc no-close-on-backdrop>
                <group-key-create v-model="groupKey"></group-key-create>
                <template #modal-footer><v-executer :loading="groupKeyCreating" :action="createGroupKey" text="Oluştur"></v-executer></template>
            </b-modal>

            <b-card :body-class="calculating ? 'p-4':'p-75'">
                <b-overlay :show="calculating" opacity="1" >  
                    <template v-if="calculated && (results || []).length">
                        <div class="row justify-content-between">
                            <div class="col-md-6 mb-75">
                                <v-select-list v-model="status" label="name" :options="statuses" placeholder="TÜMÜ"></v-select-list>
                            </div>
                            <div class="col-md-4">
                                <b-input-group class="input-group-merge">
                                    <template #prepend>
                                        <b-input-group-text >
                                            <feather-icon icon="SearchIcon"></feather-icon>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input v-model="searched" placeholder="Ara..." ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mb-75">
                            <div>
                                Toplam <span class="font-weight-bolder text-secondary">{{(c_results || []).length}}</span> adet personel.<br/>
                                Ödeme yapılacak toplam <span class="font-weight-bolder text-secondary">{{(c_selected || []).length}}</span> adet personel.
                            </div>
                            <button class="btn btn-sm btn-success" v-on:click="convertExcel">Excel Olarak İndir</button>
                        </div>
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>Personel</th>
                                    <th>Tutar (TL)</th>
                                    <th class="text-nowrap">Atama Durumu</th>
                                    <!-- <th>Puantaj Durumu</th> -->
                                    <th>Bilgi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(r,index) in c_results">
                                    <tr :key="index" :class="r.Expanded ? 'bg-light-secondary' : ''">
                                        <td class="w-70">
                                            <div class="d-flex align-items-center">
                                                <b-form-checkbox v-model="r.Include" :disabled="r.Amount == 0">
                                                    <span v-if="r.PreAssignedAmount" class="d-flex align-items-center" v-b-tooltip.noninteractive.hover.bottom="`Bu personelin; bu dönem için bu türde atanmış KYKM kayıt(lar)ı vardır.`">
                                                        <feather-icon icon="AlertOctagonIcon" class="text-secondary mr-50"></feather-icon>
                                                        <span :class="{'text-danger':!r.Include}" class="font-weight-bold text-secondary">{{r.FullName}}</span>
                                                        <span class="text-muted"> - {{r.IdentityNumber}}</span>
                                                        <span class="text-muted" v-if="r.SGKBranchName"> - {{r.SGKBranchName}}</span>
                                                        <span class="text-muted" v-if="r.SGKEntryDateStr"> - {{r.SGKEntryDateStr}}</span>
                                                        <span class="text-muted" v-if="r.SGKExitDateStr"> - {{r.SGKExitDateStr}}</span>
                                                    </span>
                                                    <template v-else>
                                                        <span :class="{'text-danger':!r.Include}" class="font-weight-bold">{{r.FullName}}</span>
                                                        <span class="text-muted"> - {{r.IdentityNumber}}</span>
                                                        <span class="text-muted" v-if="r.SGKBranchName"> - {{r.SGKBranchName}}</span>
                                                        <span class="text-muted" v-if="r.SGKEntryDateStr"> - {{r.SGKEntryDateStr}}</span>
                                                        <span class="text-muted" v-if="r.SGKExitDateStr"> - {{r.SGKExitDateStr}}</span>
                                                    </template>
                                                </b-form-checkbox>
                                            </div>
                                        </td>
                                        <td class="w-30">
                                            <div class="d-flex align-items-center">
                                                <template v-if="!r.Include || r.Amount != r.BaseAmount"> 
                                                    <input class="form-control form-control-sm w- mr-50 w-100 border border-danger" type="text" v-model="r.Description" placeholder='Açıklama giriniz!'/>
                                                </template>
                                                <template v-if="r.UCRET_NEVI == 'U' || r.UCRET_NEVI == 'S'">
                                                    <span class="text-muted mr-25">G/S:&nbsp;</span>
                                                    <input class="form-control form-control-sm w- mr-50" type="number" v-model="r.Value" v-on:input="() => { const amt = (r.Value >= 0 ? r.Value : 0) * r.Multiplier; $set(r,'Amount', amt); if(amt == 0) $set(r,'Include', false) }"/>
                                                    <span v-if="r.Net != null" class="text-muted mr-25">{{  r.Net == true ? 'Net:': 'Brüt:' }}&nbsp;</span>
                                                </template>
                                                <v-currency-input :disabled="r.UCRET_NEVI == 'U' || r.UCRET_NEVI == 'S'" :class="{'w-30':!r.Include || r.Amount!=r.BaseAmount}" input-class="text-right form-control-sm" :value="r.Amount" v-on:update-value="currencyAmount => { $set(r,'Amount', currencyAmount); if(currencyAmount == 0) $set(r,'Include', false) }"></v-currency-input>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center" :class="((r.Results || []).length || ($safe(r.Earning,'Causes') || []).length) ? 'c-pointer' : ''" v-on:click="e => ((r.Results || []).length || ($safe(r.Earning,'Causes') || []).length) ? r.Expanded = !r.Expanded : null">
                                                <template v-if="$safe(r,'Earning.Earned') == true">
                                                    <span class="material-icons-outlined text-success d-block" >check_circle</span>
                                                    <b-badge variant="success" class="ml-50">Alabilir</b-badge>
                                                </template>
                                                <template v-else-if="$safe(r,'Earning.Earned') == false && $safe(r,'Earning.EarnedAmount') == 0">
                                                    <span class="material-icons-outlined text-secondary d-block" >report</span>
                                                    <b-badge variant="secondary" class="ml-50">Alamaz</b-badge>
                                                </template>
                                                <template v-else-if="$safe(r,'Earning.Earned') == false && $safe(r,'Earning.EarnedAmount') != 0">
                                                    <span class="material-icons-outlined text-warning d-block" >error_outline</span>
                                                    <b-badge variant="warning" class="ml-50">Bir Kısmını Alabilir</b-badge>
                                                </template>
                                                <template v-else-if="r.Earning == null">
                                                    <span class="material-icons-outlined text-danger d-block">cancel</span>
                                                    <b-badge variant="danger" class="ml-50">Hakedilen Hesaplanamadı</b-badge>
                                                </template>
                                                <feather-icon v-if="(r.Results || []).length || ($safe(r.Earning,'Causes') || []).length" size="16" class="text-warning ml-50" :icon="r.Expanded ? 'ChevronDownIcon' : 'ChevronRightIcon'"></feather-icon>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center" :class="((r.Results || []).length || ($safe(r.Earning,'Causes') || []).length) ? 'c-pointer' : ''" v-on:click="e => ((r.Results || []).length || ($safe(r.Earning,'Causes') || []).length) ? r.Expanded = !r.Expanded : null">
                                                <template>
                                                    <feather-icon class="text-success mr-10" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Maaşı: '+(r.Earning.PureEarnedAmountStr || '0,00')+'₺'"></feather-icon> 
                                                    <feather-icon class="text-danger mr-50" icon="MinusCircleIcon" v-b-tooltip.noninteractive.hover.bottom="'Max. Atanabilir: '+(r.Earning.MaxEarnedAmountStr || '0,00')+'₺'"></feather-icon> 
                                                </template>
                                                <template v-if="$safe(r,'ScoreFull') == true && $safe(r,'LastScoreUpdate') != null">
                                                    <feather-icon class="text-success mr-10" icon="CheckCircleIcon" v-b-tooltip.noninteractive.hover.bottom="'Puantajı tam.'"></feather-icon> 
                                                </template>
                                                <template v-else-if="$safe(r,'ScoreFull') == false && $safe(r,'LastScoreUpdate') != null">
                                                    <feather-icon class="text-danger mr-10" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="'Puantajı tam değil.'"></feather-icon> 
                                                </template>
                                                <template v-if="$safe(r,'LastScoreUpdate')!=null">
                                                    <feather-icon class="text-warning mr-10" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Puantaj son güncelleme: '+r.LastScoreUpdate+' '"></feather-icon> 
                                                </template>
                                                <template v-else>
                                                    <feather-icon class="text-danger mr-50" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="'Puantaj yok.'"></feather-icon> 
                                                </template>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="((r.Results || []).length || ($safe(r.Earning,'Causes') || []).length) && r.Expanded" :key="'c'+index">
                                        <td colspan="4">
                                            <!-- <template v-if="($safe(r,'Earning.Earned') || []).length"> -->
                                            <template v-if="($safe(r,'Earning.Causes') || []).length">
                                                <h6 class="text-success mb-50 pt-50 pl-50 font-weight-bolder">Kazançları</h6>
                                                <ul class="list-group" :class="(r.Results.filter(r=>r.Positive==true) || []).length ? 'mb-50':null">
                                                    <li class="list-group-item text-success" v-for="(c,i) in (r.Earning.Causes).filter(f=>f.Positive==true && f.InRule==true)" :key="i">
                                                        {{c.Message }}
                                                    </li>
                                                    <li class="list-group-item text-success" v-for="(c,i) in (r.Earning.Causes).filter(f=>f.Positive==true && f.InRule==false)" :key="i">
                                                        <span class="d-flex align-items-center" v-b-tooltip.noninteractive.hover.bottom="`Seçtiğiniz kural bu kazancı içermiyor.`">
                                                        <feather-icon icon="AlertOctagonIcon" class="text-secondary mr-50"></feather-icon>
                                                        <span class="text-muted font-weight-bold text-secondary">{{c.Message}}</span>
                                                    </span>
                                                    </li>
                                                </ul>
                                                <template v-if="((r.Earning.Causes).filter(r=>r.Positive == false) || []).length > 0">
                                                    <h6 class="text-warning mt-50 pt-50 pl-50 font-weight-bolder">Kesintileri</h6>
                                                    <ul class="list-group" :class="((r.Earning.Causes).filter(r=>!r.Positive) || []).length ? 'mb-50':null">
                                                        <li class="list-group-item text-warning" v-for="(c,i) in (r.Earning.Causes.filter(f=>f.Positive==false&&f.InRule==true))" :key="i">
                                                            {{ c.Message }}
                                                        </li>
                                                        <li class="list-group-item text-success" v-for="(c,i) in (r.Earning.Causes).filter(f=>f.Positive==false && f.InRule==false)" :key="i">
                                                            <span class="d-flex align-items-center" v-b-tooltip.noninteractive.hover.bottom="`Seçtiğiniz kural bu kesintiyi içermiyor.`">
                                                            <feather-icon icon="AlertOctagonIcon" class="text-secondary mr-50"></feather-icon>
                                                            <span class="text-muted font-weight-bold text-secondary">{{c.Message}}</span>
                                                        </span>
                                                        </li>
                                                    </ul>
                                                </template>
                                            </template>
                                            <template v-if="(r.Results || []).length">
                                                <h6 class="text-danger pt-50 pl-50 font-weight-bolder">Hatalar</h6>
                                                <ul class="list-group" >
                                                    <li class="list-group-item text-danger" v-for="(e,index) in ($safe(r,'Results')||[])" :key="index">
                                                        {{ e }}
                                                    </li>
                                                </ul>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="c_results.length == 0">
                                    <tr>
                                        <td colspan="3">Girilen kriterlere uygun personel bulunamamıştır.</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <div class="mt-50" v-if="assignData.ToEmployee == true && assignData.SIRA_NO == 20 && assignData.TIP == 3">
                            <table class="table table-bordered table-sm table-hovered">
                                <tr>
                                    <th class="w-50">Kıdem Tazminatı</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.kidemTazminati" v-on:update-value="currencyAmount => parsed.kidemTazminati = currencyAmount"></v-currency-input>
                                    </td>
                                </tr>
                                <tr>
                                    <th>İhbar Tazminatı</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.ihbarTazminati" v-on:update-value="currencyAmount => parsed.ihbarTazminati = currencyAmount"></v-currency-input>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Maaş 1</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.maas1" v-on:update-value="currencyAmount => parsed.maas1 = currencyAmount"></v-currency-input>                                        
                                    </td>
                                </tr>
                                <tr>
                                    <th>Maaş 2</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.maas2" v-on:update-value="currencyAmount => parsed.maas2 = currencyAmount"></v-currency-input>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Fazla Mesai</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.fazlaMesai" v-on:update-value="currencyAmount => parsed.fazlaMesai = currencyAmount"></v-currency-input>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Tatil Mesaisi</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.tatilMesai" v-on:update-value="currencyAmount => parsed.tatilMesai = currencyAmount"></v-currency-input>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Genel Tatil Mesaisi</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.genelTatilMesai" v-on:update-value="currencyAmount => parsed.genelTatilMesai = currencyAmount"></v-currency-input>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Yıllık İzin</th>
                                    <td>
                                        <v-currency-input input-class="text-right form-control-sm" :value="parsed.yillikİzin" v-on:update-value="currencyAmount => parsed.yillikİzin = currencyAmount"></v-currency-input>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="text-left mt-75">
                            Toplam <span class="font-weight-bolder text-secondary">{{(c_results || []).length}}</span> adet personel.<br/>
                            Ödeme yapılacak toplam <span class="font-weight-bolder text-secondary">{{(c_selected || []).length}}</span> adet personel.
                        </div>
                        <div class="bg-light p-1 text-right rounded mt-75">
                            <h5>Ödenecek Toplam Tutar</h5>
                            <h2 class="mb-0 text-secondary font-weight-bolder">{{ c_total }}₺</h2>
                        </div>
                        <div class="mb-50 mt-1 text-right">
                            <b-form-checkbox inline v-model="assignData.SendToGaranti">Banka İle Ödeme Emri Oluştur</b-form-checkbox>
                        </div>
                        <div  v-if="assignData.SendToGaranti">
                            <label class="form-label">Banka Dosyası Kimliği</label>
                            <div class="d-flex"> 
                                <select :disabled="groupKeyGetting" class="form-control" v-model="assignData.GroupKey">
                                    <option :value="null" v-if="assignData.GroupKey == null">Seçiniz</option>
                                    <option v-for="(gk,i) in groupKeys" :key="i" :value="gk.GroupKey">{{ gk.GroupKey }} - [{{ gk.DateStr }}] | ({{ gk.BankAccount.Bank.BankName }} - {{ gk.BankAccount.AccountNumber }})[{{gk.BankAccount.Name}}]</option>
                                </select>
                                <v-executer class="ml-50" :loading="groupKeyGetting" :action="getGroupKeys" text="Yenile" />
                                <button v-on:click="showCreateGroupKey" class="btn btn-outline-secondary ml-50">Ekle</button>
                            </div>
                        </div>
                        <div class="text-right mt-75" v-if="c_results.length > 0">
                            <v-executer :action="assign" :disabled="isDisabled" :loading="assigning" text="Ata"></v-executer>
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="!calculating">
                            <div class="alert alert-warning mb-0">
                                <div class="alert-body">
                                    KYKM ödemesi için hesaplama verileri girilmelidir.
                                </div>
                            </div>
                        </template>
                    </template>
                </b-overlay>
            </b-card>
        </div>
    </div>
</template>

<script>
import { BCard,BInputGroup,BInputGroupText,BFormInput,BBadge,BOverlay,BFormCheckbox } from 'bootstrap-vue'
import AdvancePaymentAssign from './components/AdvancePaymentAssign.vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'
import Additional from '@/utilities/additional'
import VExecuter from '@/components/VExecuter.vue'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import xlsx from "json-as-xlsx"
import { VBTooltip } from 'bootstrap-vue'
import GroupKeyCreate from './components/GroupKeyCreate.vue'

export default {
    components:{
        BCard,
        AdvancePaymentAssign,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        BBadge,
        BOverlay,
        BFormCheckbox,
        VExecuter,
        VCurrencyInput,
        GroupKeyCreate
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    data(){
        return{
            assignData:{
                TIP:null,
                TIP_AD:null,
                SIRA_NO:null,
                SIRA_NO_AD:null,
                UCRET_NEVI:null,
                CARPAN:null,
                EmployeeDepartmentTitleIds:[],
                BranchId:null,
                SGKBranchId:null,
                ToEmployee:false,
                EmployeeId:null,
                Amount:0,
                Description:null,
                Date:null,
                TMSVault:false,
                CalculationPeriod:null,
                SendToGaranti:false,
                AnnualHolidayAdvance:false,
                GroupKey:null,
                RuleId:null,
                ExitedEmployees:false
            },
            calculatedAmount:null,
            errors:{},
            loading:false,
            calculating:false,
            calculated:false,
            assigning:false,
            results:[],
            statuses:[
                {value:1,name:"HATALILAR"},
                {value:2,name:"ALABİLİR"},
                {value:3,name:"BİR KISMINI ALABİLİR"}
            ],
            searched:"",
            groupKeys:[],
            groupKeyGetting:false,
            groupKey:{
                Date:null,
                CompanyBankAccountId:null
            },
            parsed:{
                kidemTazminati:0,
                ihbarTazminati:0,
                maas1:0,
                maas2:0,
                fazlaMesai:0,
                tatilMesai:0,
                genelTatilMesai:0,
                yillikİzin:0
            },
            status:null,
            groupKeyCreating:false,
        }
    },
    mounted(){
        this.setCurrentCalculationPeriod()
        this.getGroupKeys()
    },
    methods:{
        clearForm(){
            this.assignData.EmployeeDepartmentTitleIds = []
            this.assignData.BranchId = null
            this.assignData.ToEmployee = false
            this.assignData.EmployeeId = null
            this.assignData.Amount = 0
            this.assignData.Date = null
            this.assignData.TMSVault = false
            this.assignData.TIP = null
            this.assignData.TIP_AD = null
            this.assignData.SIRA_NO = null
            this.assignData.SIRA_NO_AD = null
            this.assignData.UCRET_NEVI = null
            this.assignData.CARPAN = null
            this.assignData.SendToGaranti = false
            this.assignData.AnnualHolidayAdvance = false
            this.assignData.GroupKey = null
            this.assignData.RuleId = null
            this.assignData.ExitedEmployees=false
            this.setCurrentCalculationPeriod()
        },
        setCurrentCalculationPeriod(){
            this.assignData.CalculationPeriod = null
            this.assignData.CalculationPeriod = moment().format('MM/YYYY')
        },
        calculate(){
            this.calculating = true
            this.calculated = false
            this.calculatedAmount = null
            const month = moment(this.assignData.Date,'YYYY-MM-DD').month() + 1
            const year = moment(this.assignData.Date,'YYYY-MM-DD').year()
            EmployeeOperationsApi.SalaryEffect.CalculateEarning({
                Month:month,
                Year:year,
                ToEmployee:this.assignData.ToEmployee,
                TargetIds:this.assignData.ToEmployee ? [this.assignData.EmployeeId] : this.assignData.EmployeeDepartmentTitleIds,
                Amount:this.assignData.Amount,
                TIP:this.assignData.TIP,
                ExitedEmployees:this.assignData.ExitedEmployees,
                SIRA_NO:this.assignData.SIRA_NO,
                UCRET_NEVI:this.assignData.UCRET_NEVI,
                CARPAN:this.assignData.CARPAN,
                SGKBranchId: this.assignData.SGKBranchId,
                OBranchId: this.assignData.BranchId,
                CalculationPeriod: this.assignData.CalculationPeriod,
                Date: this.assignData.Date,
                RuleId:this.assignData.RuleId
            }).then(res=>{
                this.calculating = false
                this.calculated = true
                this.calculatedAmount = this.assignData.Amount
                if(res.data.Success){
                    this.results = (res.data.Data || []).map(r=>({
                        ...r,
                        Expanded:false,
                        Amount:r.Earning?.EarnedAmount || 0,
                        BaseAmount:r.Earning?.EarnedAmount || 0,
                        Include:(r.Earning?.EarnedAmount || 0) > 0,
                        Description:r.Description,
                        UCRET_NEVI:this.assignData.UCRET_NEVI,
                        Value: this.assignData.Amount
                    }))
                }else{
                    this.$result(res)
                    this.results = []
                }
            }).catch(err=>{
                this.calculating = false
                this.calculated = false
                this.results = []
                this.$result(null,err)
            })
        },
        assign(){
            console.log(this.results)
            const parsedAmounts = this.assignData.ToEmployee === true &&
                this.assignData.TIP === 3 && this.assignData.SIRA_NO === 20 ? this.parsed : null
            
            this.$confirm("İşleme devam etmek istediğinize emin misiniz?",`Bu işlem ${this.assignData.TIP_AD} grubuna ait ${this.assignData.SIRA_NO_AD} türündeki KYKM işlemini toplam ${(this.results || []).length} personel için gerçekleştirecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    this.assigning = true
                    const monthYear = this.assignData.CalculationPeriod ? this.assignData.CalculationPeriod.split('/') : []
                    EmployeeOperationsApi.SalaryEffect.Assign.Common({
                        ToEmployee:this.assignData.ToEmployee,
                        Amount:this.assignData.Amount,
                        Ids:this.assignData.ToEmployee ? [this.assignData.EmployeeId] : this.assignData.EmployeeDepartmentTitleIds,
                        Date:this.assignData.Date,
                        TIP:this.assignData.TIP,
                        SIRA_NO:this.assignData.SIRA_NO,
                        UCRET_NEVI:this.assignData.UCRET_NEVI,
                        CARPAN:this.assignData.CARPAN,
                        AY: Number(monthYear[0]),
                        YIL: Number(monthYear[1]),
                        BranchId: this.assignData.BranchId,
                        AnnualHolidayAdvance:this.assignData.AnnualHolidayAdvance,
                        SendToGaranti:this.assignData.SendToGaranti,
                        GroupKey:this.assignData.GroupKey,
                        Targets:(this.results || []).map(r=>({
                            EmployeeId:r.EmployeeId,
                            SGKJobNoticeId:r.SGKJobNoticeId,
                            Amount:r.Amount,
                            ParsedAmounts:parsedAmounts,
                            Description:(r.Amount != this.calculatedAmount && r.Amount == r.BaseAmount) ? `Hakediş Tutarı: ${r.BaseAmount}` : r.Description,
                            Exclude:!r.Include,
                            Value:r.Value
                        }))
                    }).then(res=>{
                        this.assigning = false
                        this.$result(res)
                        if(res.data.Success){
                            this.clearForm()
                            this.results = []
                        }
                    }).catch(err=>{
                        this.assigning = false
                        this.$result(null,err)
                    })
                }
            })
        },
        convertExcel(){
            let settings = {
                fileName: "KYKM Ödemeleri",
                extraLength: 3,
                writeMode: "writeFile",
                writeOptions: {},
                RTL: false,
            }

            let data = [{
                sheet:"Ödemeler",
                columns:[
                    {label:'Kimlik Numarası',value:'IdentityNumber'},
                    {label:'Personel',value:'EmployeeFullName'},
                    {label:'Şube',value:'BranchName'},
                    {label:'Toplam Çalışma Günü',value:'TotalWorkingDays'},
                    {label:'Toplam Çalışma Kazancı',value:'TotalWorkingEarned'},
                    {label:'Maaş',value:'Salary'},
                    {label:'Avans',value:'Advance'},
                    {label:'Kesinti',value:'Kesinti'},
                    {label:'İcra',value:'Levy'},
                    {label:'Tutar',value:'Amount'},
                ],
                content:this.c_results?.map(r=>{
                    return {
                        IdentityNumber:r.IdentityNumber,
                        EmployeeFullName:r.FullName,
                        Amount:r.Amount,
                        Salary:r.Earning?.PureEarnedAmount || 0,
                        BranchName:r.BranchName || 0,
                        TotalWorkingDays:r.Earning?.Causes?.filter(c => c.CARPAN>0&& c.Positive && c.InRule && c.UCRET_NEVI == 'U')?.reduce((sum,c) => sum+=c.Duration,0) || 0,
                        TotalWorkingEarned:r.Earning?.Causes?.filter(c => c.Positive && c.InRule && c.UCRET_NEVI == 'U')?.reduce((sum,c) => sum+=Number(c.Amount),0) || 0,
                        Advance:r.Earning?.Causes?.filter(c => !c.Positive && c.InRule && c.Name == 'AVANS')?.reduce((sum,c) => sum+=Number(c.Amount),0) || 0,
                        Kesinti:r.Earning?.Causes?.filter(c => !c.Positive && c.InRule && c.Name == 'KESİNTİ')?.reduce((sum,c) => sum+=Number(c.Amount),0) || 0,
                        Levy:r.Earning?.Causes?.filter(c => !c.Positive && c.InRule && c.Name == 'İCRA')?.reduce((sum,c) => sum+=Number(c.Amount),0) || 0,
                    }})
                }]
            xlsx(data, settings)
        },
        getGroupKeys(){
            this.groupKeyGetting = true
            // 2 = Maaş Avansı: dosya oluştururken kullanılan tür ile aynı olmalı ki
            // listede yalnızca avans dosyaları çıksın (İcra dosyaları seçilemesin).
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyList(true, 2).then(res => {
                this.groupKeys = res.data.Data
                this.groupKeyGetting = false
            }).catch(err => {
                this.groupKeyGetting = false
            })
        },
        showCreateGroupKey(){
            this.groupKey.Date = this.assignData.Date
            this.groupKey.CompanyBankAccountId = null
            this.$showModal('create-group-key')
        },
        createGroupKey(){
            this.groupKeyCreating = true
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyCreate(this.groupKey.Date,this.groupKey.CompanyBankAccountId,2).then(res=>{
                this.groupKeyCreating = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create-group-key')
                    this.getGroupKeys()
                }
            }).catch(err => {
                this.groupKeyCreating = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        c_results(){
            return (this.results || []).filter(r=> Additional.ToEng(r.FullName).toLowerCase().includes(Additional.ToEng(this.searched || "").toLowerCase())).filter(r=>{
                if(this.status != null){
                    if(this.status.value == 1){
                        if((r.Results.length > 0)) return true
                        else return false
                    }else if(this.status.value == 2){
                        if((r.Results.length == 0) && r?.Earning?.Earned == true) return true
                        else return false
                    }if(this.status.value == 3){
                        if((r.Results.length == 0) && r?.Earning?.Earned == false) return true
                        else return false
                    }else return true
                }else return true
            })
        },
        c_selected(){
            return (this.c_results || []).filter(r=>r.Include)
        },
        c_total(){
            const price = (this.c_selected || []).reduce((sum,i)=>sum += i.Amount,0)
            return new Intl.NumberFormat('tr-TR', {
                currency: 'TRY',
                minimumFractionDigits: 2,
            }).format(price)
        },
        isDisabled() {
            const mustCheckTotal =
                this.assignData.ToEmployee === true &&
                this.assignData.SIRA_NO === 20 && this.assignData.TIP === 3

            const parsedTotal = mustCheckTotal
                ? Object.values(this.parsed).reduce(
                    (sum, val) => sum + Number(val || 0),
                    0
                    )
                : 0

            return (
                (this.assignData.SendToGaranti && this.assignData.GroupKey == null) ||
                (mustCheckTotal &&
                    parsedTotal > (this.results?.[0]?.BaseAmount || 0))
            )
        }
    }
}
</script>

<style>
.sticky{
    position:sticky;
    top:1.5rem;
    z-index: 2;
}
</style>